import { CheckCircle2, Sparkles } from 'lucide-react';

export function SuccessHero({ firstName }) {
  return (
    <>
      <div className="relative mx-auto inline-flex">
        <div className="absolute inset-0 animate-pulse rounded-full bg-emerald-300/40 blur-2xl" />
        <div className="relative flex size-20 items-center justify-center rounded-full bg-linear-to-br from-emerald-400 to-brand-600 shadow-xl shadow-brand-900/30 ring-4 ring-white sm:size-24">
          <CheckCircle2
            className="size-12 text-white sm:size-14"
            strokeWidth={2.5}
            aria-hidden="true"
          />
        </div>
      </div>

      <span className="mt-6 inline-flex items-center gap-1.5 rounded-full bg-brand-100 px-3 py-1 text-xs font-bold uppercase tracking-widest text-brand-700 ring-1 ring-brand-200">
        <Sparkles className="size-3.5" aria-hidden="true" />
        Enrollment complete
      </span>

      <h1 className="mt-5 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
        You&apos;re in, {firstName}!
      </h1>

      <p className="mx-auto mt-4 max-w-md text-base text-slate-600 sm:text-lg">
        You&apos;ve successfully enrolled. A Mind Mirth team member will reach
        out shortly to confirm your schedule and answer any questions.
      </p>
    </>
  );
}